export default __webpack_public_path__ + "static/tag-dont-2-dark-e387f0ed04dd26ed881b8026d26317f5bd27a93fc78155308f0a2fffd91eecf2.png";